import React from 'react';
import { Grid, FormControl, InputLabel, MenuItem, Select, FormHelperText, Typography, Divider } from '@mui/material';
import { FormikProps } from 'formik';
import { User } from '../../../types/user.types';

// Define a simplified FormValues interface for this component
interface FormValues {
  representativeId?: string;
  industry?: string;
  partner?: string;
  notes?: string;
  [key: string]: any; // Allow other fields that might be accessed
}

interface Props {
  formik: FormikProps<FormValues>;
  isAdmin?: boolean;
  representatives: User[];
  industries: string[];
  partners: string[];
}

const InternalInformationSection: React.FC<Props> = ({ 
  formik, 
  isAdmin, 
  representatives, 
  industries, 
  partners 
}) => (
  <>
    <Grid item xs={12}>
      <Typography variant="h6" gutterBottom sx={{ mt: 2 }}>Internal Information</Typography>
      <Divider sx={{ mb: 2 }} />
    </Grid>
    
    <Grid item xs={12} sm={6}>
      <FormControl fullWidth>
        <InputLabel id="representative-label">Representative</InputLabel>
        <Select
          labelId="representative-label"
          id="representativeId"
          name="representativeId"
          value={formik.values.representativeId || ''}
          onChange={formik.handleChange}
          onBlur={formik.handleBlur}
          error={formik.touched.representativeId && Boolean(formik.errors.representativeId)}
          label="Representative"
          disabled={!isAdmin}
          sx={{ backgroundColor: !isAdmin ? '#f5f5f5' : 'transparent' }}
        >
          <MenuItem value=""><em>None</em></MenuItem>
          {representatives.map((rep) => (
            <MenuItem key={rep._id} value={rep._id}>
              {`${rep.firstName} ${rep.lastName}`}
            </MenuItem>
          ))}
        </Select>
        {formik.touched.representativeId && formik.errors.representativeId && (
          <FormHelperText error>{formik.errors.representativeId}</FormHelperText>
        )}
        {!isAdmin && (
          <FormHelperText>Only administrators can change the representative</FormHelperText>
        )}
      </FormControl>
    </Grid>

    <Grid item xs={12} sm={6}>
      <FormControl fullWidth>
        <InputLabel id="industry-label">Industry</InputLabel>
        <Select
          labelId="industry-label"
          id="industry"
          name="industry"
          value={formik.values.industry || ''}
          onChange={formik.handleChange}
          onBlur={formik.handleBlur}
          error={formik.touched.industry && Boolean(formik.errors.industry)}
          label="Industry"
        >
          <MenuItem value="">None</MenuItem>
          {industries.map((industry) => (
            <MenuItem key={industry} value={industry}>{industry}</MenuItem>
          ))}
        </Select>
        {formik.touched.industry && formik.errors.industry && (
          <FormHelperText error>{formik.errors.industry}</FormHelperText>
        )}
      </FormControl>
    </Grid>

    <Grid item xs={12} sm={6}>
      <FormControl fullWidth>
        <InputLabel id="partner-label">Partner Account</InputLabel>
        <Select
          labelId="partner-label"
          id="partner"
          name="partner"
          value={formik.values.partner || ''}
          onChange={formik.handleChange}
          onBlur={formik.handleBlur}
          error={formik.touched.partner && Boolean(formik.errors.partner)}
          label="Partner Account"
        >
          <MenuItem value=""><em>None</em></MenuItem>
          {partners.map((partner) => (
            <MenuItem key={partner} value={partner}>{partner}</MenuItem>
          ))}
        </Select>
        <FormHelperText>Select if client was referred by a partner</FormHelperText>
      </FormControl>
    </Grid>
  </>
);

export default InternalInformationSection;
